import Vue from 'vue'
import Vuex from 'vuex'
import tracking from './modules/tracking'
import locale from './modules/locale'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {},
  modules: {
    tracking,
    locale
  }
})
